import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

import InformationHome from "pages/Servicii/ServiciiCuratenie/CurateniePostConstruct/sections/sections/InformationHome";
import TestimonialsHome from "pages/Homepage/sections/TestimonialsHome";
import ArticleContent from "pages/Servicii/ServiciiCuratenie/CurateniePostConstruct/sections/sections/ArticleContent";
import HeroSection from "pages/Servicii/ServiciiCuratenie/CurateniePostConstruct/sections/sections/HeroSection";
import ServicesSection from "pages/Servicii/ServiciiCuratenie/CurateniePostConstruct/sections/sections/Services";

function CurateniePostConstruct() {
    return (
        <>
            <Helmet>
                <title>Curățenie Post-Construct, După Constructor | Doral Cleaning</title>
                <meta
                    name="description"
                    content="Curățenie după constructor și după renovare în București și Ilfov: praf, resturi de șantier, geamuri, pardoseli. Apartamente, vile, spații comerciale."
                />
                <link rel="canonical" href="https://doral-cleaning.ro/curatenie-post-construct/" />
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "@id": "https://doral-cleaning.ro/#business",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "url": "https://doral-cleaning.ro/",
                      "telephone": "0730 407 322",
                      "foundingDate": "2006",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4",
                        "addressLocality": "București",
                        "postalCode": "040213",
                        "addressCountry": "RO"
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      },
                      "areaServed": [
                        { "@type": "City", "name": "București" },
                        { "@type": "AdministrativeArea", "name": "Județul Ilfov" },
                        { "@type": "City", "name": "Voluntari" },
                        { "@type": "City", "name": "Pantelimon" },
                        { "@type": "City", "name": "Popești-Leordeni" },
                        { "@type": "City", "name": "Bragadiru" },
                        { "@type": "City", "name": "Măgurele" },
                        { "@type": "City", "name": "Chitila" },
                        { "@type": "City", "name": "Buftea" },
                        { "@type": "City", "name": "Otopeni" }
                      ]
                    }
                    `}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "Service",
                      "name": "Curățenie post-construct",
                      "serviceType": "Curățenie după constructor",
                      "url": "https://doral-cleaning.ro/curatenie-post-construct/",
                      "provider": { "@id": "https://doral-cleaning.ro/#business" },
                      "areaServed": [
                        { "@type": "City", "name": "București" },
                        { "@type": "AdministrativeArea", "name": "Județul Ilfov" }
                      ]
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <TestimonialsHome hideLocationBlock />
                <InformationHome />
                <ArticleContent />
                <ServicesSection />
            </Card>
        </>
    );
}

export default CurateniePostConstruct;
